module.exports = __webpack_public_path__ + "img/low-preview.76b3fbc0.png";